<?xml version="1.0" encoding="UTF-8"?>
<svg width="256px" height="256px" viewBox="0 0 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>icon-aligned-right-complete</title>
    <g id="icon-aligned-right-complete" stroke="none" stroke-width="1" fill-rule="evenodd">
        <path d="M256,190 L256,232 L0,232 L0,190 L256,190 Z M162,107 L162,149 L0,149 L0,107 L162,107 Z M256,24 L256,66 L0,66 L0,24 L256,24 Z" id="Combined-Shape"  fill-rule="nonzero" transform="translate(128.000000, 128.000000) scale(-1, 1) translate(-128.000000, -128.000000) "></path>
    </g>
</svg>